import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { showSaveToCollectionModal } from '@/shared/features/quiz-collection';
import { useCTAHandlers } from '../hooks/useCTAHandlers';
import { type CTAScenario } from '../hooks/useCTAScenario';
import { MobileGuestCTAButtons } from './MobileGuestCTAButtons';
import { MobileOwnerCTAButtons } from './MobileOwnerCTAButtons';
import { MobileOwnerLockedCTAButtons } from './MobileOwnerLockedCTAButtons';
import { MobileViewerCTAButtons } from './MobileViewerCTAButtons';
import { MobileViewerLockedCTAButtons } from './MobileViewerLockedCTAButtons';
export interface MobileCTAButtonGroupProps {
  scenario: CTAScenario;
  quizId: string;
  quizData: QuizSetDetailsRes;
}
export const MobileCTAButtonGroup = ({
  scenario,
  quizId,
  quizData
}: MobileCTAButtonGroupProps) => {
  const {
    handleEnter,
    handleShare,
    handleDuplicate,
    handleEdit,
    handleGoToLms,
    handleDuplicateLocked,
    handleUpgradePlan
  } = useCTAHandlers({
    quizId,
    quizData,
    scenario
  });
  const handleSaveToCollection = () => void showSaveToCollectionModal({
    id: quizId,
    isPublic: quizData.isPublic
  });
  switch (scenario) {
    case 'guest':
      return <MobileGuestCTAButtons onCopy={handleDuplicate} onEnter={handleEnter} />;
    case 'owner':
      return <MobileOwnerCTAButtons onEnter={handleEnter} onShare={handleShare} onDuplicate={handleDuplicate} onEdit={handleEdit} />;
    case 'viewer':
      return <MobileViewerCTAButtons onDuplicate={handleDuplicate} onEnter={handleEnter} onSaveToCollection={handleSaveToCollection} />;
    case 'owner-locked':
      return <MobileOwnerLockedCTAButtons onDuplicateLocked={handleDuplicateLocked} onUpgradePlan={handleUpgradePlan} onGoToLms={handleGoToLms} onEdit={handleEdit} />;
    case 'viewer-locked':
      return <MobileViewerLockedCTAButtons onCopy={handleDuplicate} />;
    default:
      // eslint-disable-next-line no-case-declarations
      const _exhaustiveCheck: never = scenario;
      return null;
  }
};